import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useGetAllHistoryCoverQuery } from "Services/HistoryCoverApiSlice";

const HistoryLanding: React.FC = () => {
  const navigate = useNavigate();
  const plant = process.env.REACT_APP_PLANT ?? "";

  const { data: covers = [], isLoading } =
    useGetAllHistoryCoverQuery({ plant });

 
  const cover = useMemo(() => covers[0], [covers]);
  
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth < 768;
  const isTablet = windowWidth >= 768 && windowWidth < 1024;

  const heroImage = cover?.coverImageUrl
    ? encodeURI(cover.coverImageUrl)
    : "/template4/History/history-hero.jpg";

    if (!isLoading && !cover) {
  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-white">
      <div className="text-center max-w-md px-6">
        <div className="mx-auto mb-6 w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center text-3xl">
          📜
        </div>

        <h3 className="text-2xl font-semibold text-gray-800">
          History Not Available
        </h3>

        <p className="text-gray-500 mt-3">
          We are currently updating our historical archives.
        </p>
      </div>
    </div>
  );
}

  return (
    <main>
      <header
        className="tablet-portrait-bg-fix"
        style={{
          minHeight: "100vh",
          width: "100%",
          backgroundImage: `url("${heroImage}")`,
          backgroundSize: isMobile ? "auto 500%" : isTablet ? "auto 380%" : "cover",
          backgroundPosition: "top center", 
          backgroundAttachment: "fixed",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "80px 20px",
        }}
      >
 
  <div
    style={{
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(to bottom, rgba(0,0,0,0.75), rgba(0,0,0,0.6))",
    }}
  />

 
  <div
    style={{
      position: "relative",
      zIndex: 2,
      width: "100%",
      maxWidth: 900,
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.16), rgba(255,255,255,0.07))",
      backdropFilter: "blur(22px)",
      WebkitBackdropFilter: "blur(22px)",
      borderRadius: 26,
      border: "1px solid rgba(255,255,255,0.25)",
      padding: "60px 50px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 40,
      boxShadow: "0 25px 60px rgba(0,0,0,0.45)",
      textAlign: "center",
      color: "#fff",
    }}
  >
   
    <h1
      style={{
        fontSize: "clamp(30px, 4vw, 52px)",
        fontFamily: '"Melodrama", serif',
        fontWeight: 600,
        letterSpacing: 1,
      }}
    >
      {cover?.title || "History of Moore Market"}
    </h1>

    {cover?.description1 && (
      <p
        style={{
          fontSize: "clamp(16px, 1.4vw, 19px)",
          lineHeight: 1.9,
          fontStyle: "italic",
          opacity: 0.95,
          maxWidth: 760,
        }}
      >
        “{cover.description1}”
      </p>
    )}

    {(cover?.description2 || cover?.description3) && (
      <div
        style={{
          width: 80,
          height: 1,
          background: "rgba(255,255,255,0.4)",
        }}
      />
    )}

   
    {cover?.description2 && (
      <p
        style={{
          fontSize: "clamp(15px, 1.3vw, 18px)",
          lineHeight: 2,
          maxWidth: 760,
        }}
      >
        {cover.description2}
      </p>
    )}

   
    {cover?.description3 && (
      <div
        style={{
          width: 80,
          height: 1,
          background: "rgba(255,255,255,0.4)",
        }}
      />
    )}

   
    {cover?.description3 && (
      <p
        style={{
          fontSize: "clamp(15px, 1.3vw, 18px)",
          lineHeight: 2,
          maxWidth: 760,
        }}
      >
        {cover.description3}
      </p>
    )}

   
    {/* <button
      onClick={() => navigate("/history-timeline")}
      style={{
        marginTop: 20,
        padding: "14px 40px",
        borderRadius: 40,
        border: "1px solid #ffffff",
        background: "transparent",
        color: "#ffffff",
        fontWeight: 600,
        fontSize: 16,
        cursor: "pointer",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#ffffff";
        e.currentTarget.style.color = "#000";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "transparent";
        e.currentTarget.style.color = "#ffffff";
      }}
    >
      View Our Timeline
    </button> */}
  </div>
</header>


    </main>
  );
};

export default HistoryLanding;
